import React from 'react'
import classNames from 'classnames'
import styles from './Stepper.module.scss'

interface StepperProps {
    steps: number
    currentStep: number
}

export const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
    return (
        <div className={styles.Steps}>
            {Array.from({ length: steps }).map((_, index) => (
                <span
                    key={index}
                    className={classNames(styles.stepDot, {
                        [styles.stepDotActive]: index + 1 <= currentStep,
                    })}
                />
            ))}
        </div>
    )
}
